import { createSelector } from '@reduxjs/toolkit';
import { MediaOwnerMeta } from 'components/common/types/MediaOwners.types';
import { RootState } from 'store';
import { UnderlyingMediaOwner } from './reducer';

export const getAvailableMediaOwners = createSelector(
  [(state: RootState) => state.reseller.underlyingMediaOwners],
  (underlyingMediaOwners: UnderlyingMediaOwner): string[] => {
    return Object.keys(underlyingMediaOwners).sort() || [];
  },
);

export const getResellerDealMediaOwners = createSelector(
  [getAvailableMediaOwners, (state: RootState) => state.dealManagement.commonDeal.currentLine.mediaOwnerMeta],
  (availableMediaOwners: string[], mediaOwnerMeta: MediaOwnerMeta[]): string[] => {
    return mediaOwnerMeta?.length > 0 ? mediaOwnerMeta.map(({ code }) => code) : availableMediaOwners;
  },
);

export const getUnderlyingMediaOwnerRegions = createSelector(
  [getResellerDealMediaOwners, (state: RootState) => state.reseller.underlyingMediaOwners],
  (mediaOwners: string[], underlyingMediaOwners: UnderlyingMediaOwner): string[] => {
    return mediaOwners.reduce((acc, identifier) => {
      if (underlyingMediaOwners[identifier]) acc.push(underlyingMediaOwners[identifier].countryName);
      return acc;
    }, [] as string[]);
  },
);
